// The demo runs the Windows app's offline engine in a browser: Node's crypto, as far as it uses it.
export const randomUUID = (): string => crypto.randomUUID();
